import React from "react";
import Modal from "react-modal";
import { useRecoilState, useRecoilValue } from "recoil";
import styled from "styled-components";
import { langState } from "../../recoil/lang";
import "../../styles/CustomModal.css";
import { getHotelInfoTitle, getStoreName } from "../../utils/util";

import {
  ContentCardDataType,
  ContentCardDetailType,
} from "../../controller/MasterController";
import {
  authStoreType,
  masterStoreState,
  qrAuthState,
  qrAuthType,
} from "../../recoil/auth";

const CardContentModal = (oProps: {
  isVisible: boolean;
  setVisible: any;
  cardData: ContentCardDataType;
  cardDetailData: ContentCardDetailType;
}) => {
  const [lang, setLang] = useRecoilState<number>(langState);
  const master = useRecoilValue<authStoreType>(masterStoreState);
  const auth = useRecoilValue<qrAuthType>(qrAuthState);

  const onCloseModal = () => {
    oProps.setVisible(false);
  };
  const cardData = oProps.cardData;
  const cardDetailData = oProps.cardDetailData;
  if (cardData === undefined) return null;

  return (
    <Modal
      isOpen={oProps.isVisible}
      onRequestClose={onCloseModal}
      className="cardContentModal modal-content"
      closeTimeoutMS={100}
      ariaHideApp={false}
    >
      <Style>
        <div className="modal">
          <div className="header">
            <h2>{getStoreName(master, lang)}</h2>
            <h1>{getHotelInfoTitle(cardData, lang)}</h1>
            <div className="bar" />
          </div>
          <img
            className="closeIcon"
            src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_arrow_left.svg`}
            alt="ic"
            onClick={onCloseModal}
          />
          <div className="modalContentWrap">
            {cardDetailData?.content_data?.map((item, idx: number) => (
              <div className="contentWrap" key={idx}>
                {item.content_type === 0 ? (
                  <img src={item.url} alt="호텔소개 이미지" />
                ) : (
                  <p>{item.content}</p>
                )}
              </div>
            ))}
          </div>
        </div>
      </Style>
    </Modal>
  );
};

export default CardContentModal;

const Style = styled.div`
  .modal {
    display: flex;
    align-items: center;
    justify-content: start;
    flex-direction: column;
    height: 98dvh;
    text-align: center;
  }
  .header {
    padding: 40px 0;
    text-align: center;
    top: 0;

    h2 {
      font-size: 20px;
      line-height: 32px;
      font-weight: 300;
      color: #ffffff;
    }
    h1 {
      font-size: 30px;
      line-height: 38px;
      font-weight: 600;
      color: #ffffff;
    }
    .bar {
      margin: 0 auto;
      margin-top: 20px;
      width: 50px;
      height: 4px;
      border-radius: 50px;
      background: #4dd2ae;
    }
  }
  .closeIcon {
    position: absolute;
    left: 2%;
    top: 1.5%;
  }
  /* modalContentWrap */
  .modalContentWrap {
    width: 100%;
    height: 100%;
    overflow-y: auto !important;
    margin-bottom: 20px;

    img {
      width: 100%;
      margin-bottom: 12px;
      object-fit: contain;

      padding: 0 20px;
    }
    p {
      margin-bottom: 12px;
      padding: 0 20px;
      font-size: 14px;
      font-weight: 300;
      line-height: 22px;
      text-align: left;
    }
  }
`;
